import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useDetector,
  useEquipment,
  useEquipmentMide,
  useUser,
} from "@services/servicesGenericsTables";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const CountingIodo131 = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { currentCounting } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("CON");
  const { loading } = useEquipmentMide();
  const { detectorsList } = useDetector();

  const watchEquipment = form.watch("counting_equipment");

  const filterDetectors = useMemo(() => {
    const idsEquipment = watchEquipment?.map((e) => e.id);
    return detectorsList.filter(
      (detector) => idsEquipment?.includes(detector.equipment.id) || false
    );
  }, [watchEquipment, detectorsList]);

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              name="counting_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              validation={{
                required:
                  filteredProcedures?.length > 0
                    ? "La parte es requerida"
                    : false,
              }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              multiple
              loading={loading}
              disabled={!currentCounting.canEdit}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_detector"))}
              name="counting_detector"
              options={filterDetectors}
              label="Detector"
              getOptionLabel={(option) => `${option.name}` || ""}
              multiple
              disabled={!currentCounting.canEdit}
            />
            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de contaje"
              validation={{
                required: "La fecha de contaje es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />
          </ResponsiveFormContainer>

          <ResponsiveFormContainer columns={5} mt={2}>
            <MTextField
              key={JSON.stringify(form.getValues("total_sample_counting_time"))}
              name="total_sample_counting_time"
              placeholder="Tiempo de contaje (min)"
              label="Tiempo de contaje (min)"
              validation={{
                required:
                  "El tiempo total de contaje de la muestra es requerido",
              }}
              type="number"
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />

            <MTextField
              key={JSON.stringify(form.getValues("total_cpm_sample"))}
              name="total_cpm_sample"
              placeholder="cpm muestra"
              label="cpm muestra"
              type="number"
              fullWidth
              disabled={!currentCounting.canEdit}
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountingIodo131;
